import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import Layout from '@shared/ui/organisms/layout/Layout';
import AccessRequired from '@features/settings/pages/components/AccessRequired';
import { WithCurrentUser } from '@shared/hooks/WithCurrentUser';
import { isCompanyAdminUser, isOfficeAdminUser } from '@shared/utils/AccessControl';
import { useLockersEnabled } from './data/UseLockersEnabled';
import { useLockerOffices } from './data/UseLockerOffices';
import { loadLockerSummary } from './data/lockers.duck';
import { AdminLockerDirectory } from './components/AdminLockerDirectory';
import { MemberLockerView } from './components/MemberLockerView';

/**
 * One route, two pages. An admin manages inventory; everyone else is answering "which locker is
 * mine" and "is anything free". There is no toggle between the two because the backend does not
 * send a member the data the admin view is made of.
 */
export function LockerDirectoryPage() {
  const dispatch = useDispatch();
  const currentUser = WithCurrentUser();
  const lockersEnabled = useLockersEnabled();

  const canManage = isCompanyAdminUser(currentUser) || isOfficeAdminUser(currentUser);
  const { officeOptions, selectedOfficeOption, selectedOfficeId, selectedOfficeName, selectOffice } =
    useLockerOffices(lockersEnabled);

  useEffect(() => {
    if (!lockersEnabled) return;
    dispatch(loadLockerSummary());
  }, [dispatch, lockersEnabled]);

  // The sub-header hides the link, but the route is still reachable by typing the URL.
  if (!lockersEnabled) {
    return (
      <Layout>
        <AccessRequired visible={true} companyAdminsRequired={true} />
      </Layout>
    );
  }

  return (
    <Layout hideFooter={true} style={{ backgroundColor: 'white' }}>
      {canManage
        ? <AdminLockerDirectory officeOptions={officeOptions}
                                selectedOfficeOption={selectedOfficeOption}
                                selectedOfficeId={selectedOfficeId}
                                selectedOfficeName={selectedOfficeName}
                                selectOffice={selectOffice} />
        : <MemberLockerView selectedOfficeId={selectedOfficeId}
                            selectedOfficeName={selectedOfficeName} />}
    </Layout>
  );
}
